import 'twin.macro';
import React from 'react';

interface Props {
  category: string;
  children: React.ReactNode;
}

export default function CategoryResult(props: Props) {
  const { category } = props;
  return (
    <div>
      <h2 tw="py-2 px-2 text-xs font-semibold text-neutral-intense">
        {category}
      </h2>
      <div tw="-mx-2 text-neutral-moderate space-y-3">{props.children}</div>
    </div>
  );
}
